import Selector from '../../../../components/Selector';
import { DetailServices } from './DetailServices';
import { BodyshopServices } from './BodyshopServices';
import { Parts } from './Parts';
import { Tables } from './Tables';
import { AestheticsServices } from './AestheticsServices';
import { BudgetImageChecklist } from './BudgetImageChecklist';
import { ActionsButton } from '../ActionsButton';
import { TotalBudget } from '../TotalBudget';
import { BUDGET_TABS } from '../../utils/enum';

export const BudgetTabs = (props) => {
  const {
    budget,
    showBudgetItems,
    onChange,
    client,
    clientLoading,
    values,
    setOpen,
    vehicle,
    vehicleLoading,
    menuOpen,
    creatableOpen,
    createOption,
    divCreatable,
    deleteOptions,
    paymentOptions,
    company,
    isFullscreen,
    isntLinearHour,
    hvTable,
    setIsntLinearHour,
    bodyshopService,
    onRemoveService,
    changeValue,
    onRemovePiece,
    changePartsValue,
    openEditModal,
    parts,
    isOpen,
    onRemoveAeService,
    aeService,
    compareValues,
    sendWhatsapp,
    toShare,
    isLoading,
    onRemove,
    onClone,
    onSave,
    totalParts,
    totalSum,
    totalBodyshopService,
    totalAeService,
    changeValueAeService,
    reloadPrint,
    printCompany,
    setCurrentClientId,
    setCurrentVehicleId,
    setHasCreated,
    setOldValues,
    setReloadPrint,
    setValues,
    reloadConsultants,
    reloadPaymentOptions,
  } = props;

  return (
    <div className="modal-content-wrapper">
      <div className="main-content-modal1">
        <div style={{ textAlign: 'center' }}>
          {isFullscreen ? (
            budget === BUDGET_TABS.DETAILS ? (
              <div className="full-screen-tabs-container">
                <Selector
                  handleClick={() => showBudgetItems(1)}
                  buttonClass={budget === 1 ? 'highlighted' : ''}
                  id={'Detalhes'}
                  name={'Detalhes'}
                />
                <Selector
                  handleClick={() => showBudgetItems(4)}
                  buttonClass={budget === 4 ? 'highlighted' : ''}
                  id={'Tabelas'}
                  name={'Tabelas'}
                />
              </div>
            ) : null
          ) : (
            <div className="modal-budget-nav-tabs-container">
              <Selector
                handleClick={() => showBudgetItems(1)}
                buttonClass={
                  budget === BUDGET_TABS.DETAILS ? 'highlighted' : ''
                }
                id={'Detalhes'}
                name={'Detalhes'}
              />
              <Selector
                handleClick={() => showBudgetItems(8)}
                buttonClass={
                  budget === BUDGET_TABS.IMAGE_CHECKLIST ? 'highlighted' : ''
                }
                id={'ChecklistEntrada'}
                name={'Fotos'}
              />
              <Selector
                handleClick={() => showBudgetItems(2)}
                buttonClass={
                  budget === BUDGET_TABS.BODYSHOP ? 'highlighted' : ''
                }
                id={'ServiçosFunilaria'}
                name={'Serviços Funilaria e Pintura'}
              />
              <Selector
                handleClick={() => showBudgetItems(5)}
                buttonClass={
                  budget === BUDGET_TABS.AESTHETICS ? 'highlighted' : ''
                }
                id={'ServiçosEstetica'}
                name={'Serviços'}
              />
              <Selector
                handleClick={() => showBudgetItems(3)}
                buttonClass={`${
                  budget === BUDGET_TABS.PARTS ? 'highlighted' : ''
                }`}
                id={'Peças'}
                name={'Peças'}
              />
            </div>
          )}
        </div>

        <DetailServices
          budget={budget}
          onChange={onChange}
          client={client}
          clientLoading={clientLoading}
          values={values}
          setOpen={setOpen}
          vehicle={vehicle}
          vehicleLoading={vehicleLoading}
          menuOpen={menuOpen}
          creatableOpen={creatableOpen}
          createOption={createOption}
          divCreatable={divCreatable}
          deleteOptions={deleteOptions}
          paymentOptions={paymentOptions}
          company={company}
          setCurrentClientId={setCurrentClientId}
          setCurrentVehicleId={setCurrentVehicleId}
          reloadPrint={reloadPrint}
          setHasCreated={setHasCreated}
          setOldValues={setOldValues}
          setReloadPrint={setReloadPrint}
          setValues={setValues}
          reloadConsultants={reloadConsultants}
          reloadPaymentOptions={reloadPaymentOptions}
        />
        <BodyshopServices
          budget={budget}
          values={values}
          onChange={onChange}
          isntLinearHour={isntLinearHour}
          hvTable={hvTable}
          setIsntLinearHour={setIsntLinearHour}
          setOpen={setOpen}
          bodyshopService={bodyshopService}
          onRemoveService={onRemoveService}
          changeValue={changeValue}
        />
        <Parts
          budget={budget}
          isOpen={isOpen}
          setOpen={setOpen}
          onRemovePiece={onRemovePiece}
          changePartsValue={changePartsValue}
          openEditModal={openEditModal}
          parts={parts}
        />
        <Tables
          budget={budget}
          showBudgetItems={showBudgetItems}
          isOpen={isOpen}
          setOpen={setOpen}
          onRemovePiece={onRemovePiece}
          changePartsValue={changePartsValue}
          openEditModal={openEditModal}
          parts={parts}
          values={values}
          onChange={onChange}
          setIsntLinearHour={setIsntLinearHour}
          isntLinearHour={isntLinearHour}
          hvTable={hvTable}
          onRemoveService={onRemoveService}
          changeValue={changeValue}
          bodyshopService={bodyshopService}
          onRemoveAeService={onRemoveAeService}
          aeService={aeService}
        />
        <AestheticsServices
          budget={budget}
          setOpen={setOpen}
          onRemoveAeService={onRemoveAeService}
          values={values}
          changeValueAeService={changeValueAeService}
          aeService={aeService}
        />
        <BudgetImageChecklist
          budget={budget}
          onChange={onChange}
          values={values}
        />
        {budget !== BUDGET_TABS.IMAGE_CHECKLIST && (
          <div>
            <TotalBudget
              budget={budget}
              totalParts={totalParts}
              totalSum={totalSum}
              totalBodyshopService={totalBodyshopService}
              totalAeService={totalAeService}
              values={values}
              onChange={onChange}
            />

            <ActionsButton
              reloadPrint={reloadPrint}
              compareValues={compareValues}
              sendWhatsapp={sendWhatsapp}
              toShare={toShare}
              isLoading={isLoading}
              values={values}
              onRemove={onRemove}
              onClone={onClone}
              onSave={onSave}
              printCompany={printCompany}
              client={client}
              totalSum={totalSum}
              totalBodyshopService={totalBodyshopService}
              totalParts={totalParts}
              totalAeService={totalAeService}
              bodyshopService={bodyshopService}
              aeService={aeService}
              parts={parts}
              observation={values.observation ?? company.budgetNote}
            />
          </div>
        )}
      </div>
    </div>
  );
};
